import * as React from 'react';
import PrimaryLockup from './lockup-white.svg';

function SvgComponent(props: React.ImgHTMLAttributes<any>) {
  return <img src={PrimaryLockup} {...props} />;
}

export default SvgComponent;
